const MRSearchCatalog = {
  promise: null,
  groups: [["zapato", "zapatos", "botin", "botines", "bota", "botas", "calzado"], ["zapatilla", "zapatillas", "sneaker", "sneakers"], ["casaca", "casacas", "chaqueta", "chaquetas", "parka", "parkas", "jacket", "jackets"], ["balaclava", "balaclavas", "pasamontanas"], ["overol", "overoles", "overall", "overalls", "mameluco", "mamelucos", "coverall", "coveralls"], ["polo", "polos", "camiseta", "camisetas", "tshirt", "tshirts"], ["pantalon", "pantalones", "trouser", "trousers"], ["mandil", "mandiles", "delantal", "delantales", "apron", "aprons"], ["impermeable", "impermeables", "lluvia", "rainwear"], ["chaleco", "chalecos", "vest", "vests"], ["lente", "lentes", "gafa", "gafas", "anteojo", "anteojos"], ["antiparra", "antiparras", "goggle", "goggles", "monogafa", "monogafas"], ["sobrelente", "sobrelentes", "sobregafa", "sobregafas"], ["visor", "visores", "pantalla", "pantallas", "careta", "caretas", "faceshield", "faceshields"], ["mascara", "mascaras", "mask", "masks"], ["orejera", "orejeras", "earmuff", "earmuffs"], ["tapon", "tapones", "tapaoido", "tapaoidos", "earplug", "earplugs"], ["auditiva", "auditivo", "auditivos", "auditivas", "audicion", "oido", "oidos"], ["casco", "cascos", "helmet", "helmets"], ["barbiquejo", "barbiquejos", "barboquejo", "barboquejos", "mentonera", "mentoneras", "chinstrap", "chinstraps"], ["guante", "guantes", "glove", "gloves"], ["jebe", "caucho", "rubber"], ["manga", "mangas", "manguito", "manguitos"], ["soldador", "soldadores", "soldadura", "soldar", "welding"], ["ignifugo", "ignifugos", "ignifuga", "ignifugas", "antiflama", "antiflamas", "flame", "flameproof"], ["descartable", "descartables", "desechable", "desechables", "disposable", "disposables"], ["arnes", "arneses", "harness", "harnesses"], ["retractil", "retractiles", "autorretractil", "autorretractiles", "srl"], ["conector", "conectores", "connector", "connectors"], ["mosqueton", "mosquetones", "carabiner", "carabiners"], ["anticaida", "anticaidas", "caida", "caidas", "fallprotection"], ["lineadevida", "lineasdevida", "lifeline", "lifelines"], ["lineadeconexion", "lineasdeconexion", "lanyard", "lanyards"], ["anclaje", "anclajes", "anchorage", "anchor", "anchors"], ["descensor", "descensores", "descender", "descenders"], ["ascendedor", "ascendedores", "ascender", "ascenders"], ["cordino", "cordinos", "cordinn", "cordines"], ["cuerda", "cuerdas", "rope", "ropes"], ["respirador", "respiradores", "respirator", "respirators"], ["mascarilla", "mascarillas", "tapaboca", "tapabocas", "cubreboca", "cubrebocas"], ["fullface", "caracompleta", "rostrocompleto"], ["mediacara", "semimascara", "semimascaras"], ["cartucho", "cartuchos", "cartridge", "cartridges"], ["filtro", "filtros", "filter", "filters"], ["prefiltro", "prefiltros", "prefilter", "prefilters"], ["detectorgases", "medidorgases", "gasdetector", "gasdetectors"], ["calibracion", "calibrar", "calibration"], ["bloqueo", "bloqueos", "lockout", "loto"], ["etiqueta", "etiquetas", "etiquetado", "tagout"], ["cerrojo", "cerrojos", "hasp", "hasps"], ["candado", "candados", "padlock", "padlocks"], ["lavaojos", "lavaojo", "eyewash"], ["ducha", "duchas", "shower", "showers"], ["extintor", "extintores", "extinguidor", "extinguidores", "extinguisher", "extinguishers"], ["pqs", "polvoquimicoseco"], ["co2", "dioxidodecarbono"], ["botiquin", "botiquines", "firstaidkit"], ["camilla", "camillas", "stretcher", "stretchers"], ["collarin", "collarines"], ["salvavidas", "flotacion", "lifejacket", "lifejackets"], ["absorbente", "absorbentes", "absorbent", "absorbents"], ["antiderrame", "antiderrames", "derrame", "derrames", "spill"], ["cordonabsorbente", "salchicha", "salchichas", "sock", "socks"], ["almohadilla", "almohadillas", "pano", "panos", "pad", "pads"], ["bandeja", "bandejas", "cubeta", "cubetas", "tray", "trays"], ["palet", "palets", "pallet", "pallets", "parihuela", "parihuelas"], ["senal", "senales", "senaletica", "senalizacion", "letrero", "letreros", "cartel", "carteles"], ["cono", "conos", "cone", "cones"], ["barrera", "barreras", "barrier", "barriers"], ["cinta", "cintas", "tape", "tapes"], ["linterna", "linternas", "flashlight", "flashlights", "torch", "torches"], ["frontal", "frontales", "headlamp", "headlamps"], ["lampara", "lamparas", "lamp", "lamps"], ["bateria", "baterias", "battery", "batteries"], ["grillete", "grilletes", "shackle", "shackles"], ["gancho", "ganchos", "hook", "hooks"], ["polipasto", "polipastos", "tecle", "tecles"], ["escalera", "escaleras", "ladder", "ladders"], ["rodillera", "rodilleras", "kneepad", "kneepads"], ["bloqueadorsolar", "protectorsolar", "sunscreen"], ["chalecoreflectivo", "chalecoreflectante"], ["reflectivo", "reflectivos", "reflectiva", "reflectivas", "reflectante", "reflectantes"], ["fotoluminiscente", "fotoluminiscentes", "fotoluminescente", "fotoluminescentes"], ["celtex", "celtec", "celteck", "pvcfoam"], ["contraincendio", "contraincendios", "incendio", "incendios"], ["hauk", "hawk"], ["petzl", "petzel"]],
  phrases: [["\\b(?:(?:cordon|cordones) absorbentes?|mangas? absorbentes?|salchichas? absorbentes?)\\b", "cordonabsorbente"], ["\\b(?:protector(?:es)? de oidos?|protector(?:es)? auditivos?)\\b", "auditiva"], ["\\b3\\s+m\\b", "3m"], ["\\bsteel\\s+pro\\b", "steelpro"], ["\\bdelta\\s+plus\\b", "deltaplus"], ["\\bloto\\s+master\\b", "lotomaster"], ["\\b(?:full[ -]?face|cara completa|rostro completo|facial completo)\\b", "fullface"], ["\\b(?:media cara|medio rostro|medio facial|half[ -]?face)\\b", "mediacara"], ["\\b(?:lineas? de vida|life[ -]?lines?)\\b", "lineadevida"], ["\\b(?:lineas? de conexion|cabos? de vida)\\b", "lineadeconexion"], ["\\b(?:bloques? retractiles?|bloques? retractil)\\b", "retractil"], ["\\b(?:detector(?:es)? de gas(?:es)?|medidor(?:es)? de gas(?:es)?|gas detectors?)\\b", "detectorgases"], ["\\b(?:lava[ -]?ojos?|ducha ocular)\\b", "lavaojos"], ["\\b(?:polvo quimico seco)\\b", "polvoquimicoseco"], ["\\b(?:dioxido de carbono|co[ -]?2)\\b", "co2"], ["\\b(?:botiquin de primeros auxilios|first aid kit)\\b", "botiquin"], ["\\b(?:protector solar|bloqueador solar|crema solar)\\b", "protectorsolar"], ["\\b(?:chalecos? reflectivos?|chalecos? reflectantes?)\\b", "chalecoreflectivo"], ["\\b(?:cinta anti deslizante)\\b", "cinta antideslizante"], ["\\b(?:foto luminiscente|foto luminescente)\\b", "fotoluminiscente"], ["\\b(?:contra incendios?|fire protection)\\b", "contraincendio"]],
  normalize(value) { return String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase(); },
  words(value) {
    let text = this.normalize(value);
    this.phrases.forEach(([pattern, replacement]) => { text = text.replace(new RegExp(pattern, 'g'), replacement); });
    return text.match(/[a-z0-9]+/g) || [];
  },
  async load() {
    if (this.promise) return this.promise;
    this.promise = (async () => {
      const base = new URL(window.routes.predictive_search_url, location.origin).pathname.replace(/\/search\/suggest$/, '/collections/all');
      const read = async (page) => {
        const url = new URL(base, location.origin);
        url.searchParams.set('section_id', 'predictive-search');
        url.searchParams.set('page', String(page));
        const response = await fetch(url, { credentials: 'same-origin' });
        if (!response.ok) throw new Error('Search index unavailable');
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const node = doc.querySelector('[data-mr-search-index]');
        if (!node) throw new Error('Search index missing');
        return JSON.parse(node.textContent);
      };
      const first = await read(1), products = [...first.products];
      let page = 2;
      await Promise.all(Array.from({length: Math.min(3, Math.max(0, first.pages - 1))}, async () => {
        while (page <= first.pages) { const next = page++; products.push(...(await read(next)).products); }
      }));
      return { labels: first.labels, products: [...new Map(products.map(p => [p.id, p])).values()] };
    })().catch(error => { this.promise = null; throw error; });
    return this.promise;
  },
  vocabularies: new WeakMap(),
  oneEdit(a, b) {
    if (a === b || Math.abs(a.length - b.length) > 1) return false;
    if (a.length === b.length) {
      const differences = [];
      for (let i=0;i<a.length;i++) if (a[i] !== b[i]) differences.push(i);
      if (differences.length === 1) return true;
      return differences.length === 2 && differences[1] === differences[0]+1 && a[differences[0]] === b[differences[1]] && a[differences[1]] === b[differences[0]];
    }
    const shorter=a.length<b.length?a:b, longer=a.length<b.length?b:a;
    let i=0,j=0,skipped=false;
    while(i<shorter.length && j<longer.length) {
      if(shorter[i]===longer[j]) {i++;j++;}
      else {if(skipped)return false;skipped=true;j++;}
    }
    return true;
  },
  correction(products, query) {
    let vocabulary=this.vocabularies.get(products);
    if(!vocabulary) {
      const words=new Set(this.groups.flat());
      const protectedCodes=new Set();
      products.forEach(p=>{
        this.words(p.title+' '+p.vendor+' '+p.type).forEach(w=>words.add(w));
        (p.codes||[]).forEach(c=>{const code=this.normalize(c).replace(/[^a-z0-9]/g,'');if(code)protectedCodes.add(code);});
      });
      vocabulary={all:words,candidates:[...words].filter(w=>/^[a-z]{5,}$/.test(w)&&!protectedCodes.has(w)),protectedCodes};
      this.vocabularies.set(products,vocabulary);
    }
    const tokens=this.words(query), stop=new Set(['de','del','la','el','los','las','para','con','y','un','una','en','por']);
    let changed=0;
    const corrected=[];
    for(const token of tokens) {
      if(stop.has(token)||!/^[a-z]{5,}$/.test(token)||vocabulary.protectedCodes.has(token)||vocabulary.all.has(token)||vocabulary.candidates.some(w=>w.startsWith(token))) {corrected.push(token);continue;}
      const candidates=vocabulary.candidates.filter(word=>this.oneEdit(token,word));
      if(!candidates.length)return null;
      const group=this.groups.find(g=>g.includes(candidates[0]));
      if(candidates.length>1 && (!group||!candidates.every(w=>group.includes(w))))return null;
      if(++changed>1)return null;
      corrected.push(candidates[0]);
    }
    return changed?corrected.join(' '):null;
  },
  search(products, query) {
    const exact=this.rank(products,query);
    if(exact.length)return {products:exact,correctedQuery:null};
    const correction=this.correction(products,query);
    if(!correction)return {products:[],correctedQuery:null};
    const matches=this.rank(products,correction);
    return {products:matches,correctedQuery:matches.length?correction:null};
  },
  rank(products, query) {
    const normalized = this.normalize(query), tokens = this.words(query);
    const stop = new Set(['de','del','la','el','los','las','para','con','y','un','una','en','por']);
    const meaningful = tokens.filter(t => !stop.has(t));
    if (!meaningful.length) return [];
    const alternatives = meaningful.map(token => {
      const group = this.groups.find(g => g.includes(token)) || (token.length >= 3 ? this.groups.find(g => g.some(w => w.startsWith(token))) : null);
      return group ? [...new Set([token, ...group])] : [token];
    });
    const compactQuery = meaningful.join('');
    return products.map(p => {
      const title = this.normalize(p.title), brand = this.normalize(p.vendor), type = this.normalize(p.type);
      const words = this.words(title + ' ' + brand + ' ' + type), titleWords = this.words(title);
      const codes = (p.codes || []).map(c => this.normalize(c).replace(/[^a-z0-9]/g, '')).filter(Boolean);
      const compactTitle = title.replace(/[^a-z0-9]/g, '');
      const codeMatch = compactQuery.length >= 2 && (codes.some(c => c.includes(compactQuery)) || /[0-9]/.test(compactQuery) && compactTitle.includes(compactQuery));
      if (!codeMatch && !alternatives.every(group => group.some(t => words.some(w => w.startsWith(t))))) return null;
      const score = (title.startsWith(normalized) ? 100 : 0) + ((' '+title+' ').includes(' '+normalized+' ') ? 50 : 0) + (codeMatch ? 120 : 0) + meaningful.filter(t => titleWords.some(w => w.startsWith(t))).length * 10 + alternatives.filter(g => g.some(t => titleWords.some(w => w.startsWith(t)))).length * 20;
      return {p, score};
    }).filter(Boolean).sort((a,b) => b.score - a.score || a.p.title.localeCompare(b.p.title)).map(x => x.p);
  }
};

class PredictiveSearch extends SearchForm {
  constructor() {
    super();
    this.cachedResults = {};
    this.predictiveSearchResults = this.querySelector('[data-predictive-search]');
    this.allPredictiveSearchInstances = document.querySelectorAll('predictive-search');
    this.isOpen = false;
    this.abortController = new AbortController();
    this.searchTerm = '';

    this.setupEventListeners();
  }

  setupEventListeners() {
    this.input.form.addEventListener('submit', this.onFormSubmit.bind(this));

    this.input.addEventListener('focus', this.onFocus.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.addEventListener('keyup', this.onKeyup.bind(this));
    this.addEventListener('keydown', this.onKeydown.bind(this));
  }

  getQuery() {
    return this.input.value.trim();
  }

  onChange() {
    super.onChange();
    const newSearchTerm = this.getQuery();
    if (!this.searchTerm || !newSearchTerm.startsWith(this.searchTerm)) {
      // Remove the results when they are no longer relevant for the new search term
      // so they don't show up when the dropdown opens again
      this.querySelector('#predictive-search-results-groups-wrapper')?.remove();
    }

    // Update the term asap, don't wait for the predictive search query to finish loading
    this.updateSearchForTerm(this.searchTerm, newSearchTerm);

    this.searchTerm = newSearchTerm;

    if (!this.searchTerm.length) {
      this.close(true);
      return;
    }

    this.getSearchResults(this.searchTerm);
  }

  onFormSubmit(event) {
    if (!this.getQuery().length || this.querySelector('[aria-selected="true"] a')) event.preventDefault();
  }

  onFormReset(event) {
    super.onFormReset(event);
    if (super.shouldResetForm()) {
      this.searchTerm = '';
      this.abortController.abort();
      this.abortController = new AbortController();
      this.closeResults(true);
    }
  }

  onFocus() {
    const currentSearchTerm = this.getQuery();

    if (!currentSearchTerm.length) return;

    if (this.searchTerm !== currentSearchTerm) {
      // Search term was changed from other search input, treat it as a user change
      this.onChange();
    } else if (this.getAttribute('results') === 'true') {
      this.open();
    } else {
      this.getSearchResults(this.searchTerm);
    }
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onKeyup(event) {
    if (event.target.closest('[data-mr-suggest-add]')) return;
    if (!this.getQuery().length) this.close(true);
    event.preventDefault();

    switch (event.code) {
      case 'ArrowUp':
        this.switchOption('up');
        break;
      case 'ArrowDown':
        this.switchOption('down');
        break;
      case 'Enter':
        this.selectOption();
        break;
    }
  }

  onKeydown(event) {
    if (event.target.closest('[data-mr-suggest-add]')) return;
    // Prevent the cursor from moving in the input when using the up and down arrow keys
    if (event.code === 'ArrowUp' || event.code === 'ArrowDown') {
      event.preventDefault();
    }
  }

  updateSearchForTerm(previousTerm, newTerm) {
    const searchForTextElement = this.querySelector('[data-predictive-search-search-for-text]');
    const currentButtonText = searchForTextElement?.innerText;
    if (currentButtonText) {
      if (previousTerm && currentButtonText.split(previousTerm).length > 2) {
        // The new term matches part of the button text and not just the search term, do not replace to avoid mistakes
        return;
      }
      const newButtonText = currentButtonText.replace(previousTerm, newTerm);
      searchForTextElement.innerText = newButtonText;
    }
  }

  switchOption(direction) {
    if (!this.getAttribute('open')) return;

    const moveUp = direction === 'up';
    const selectedElement = this.querySelector('[aria-selected="true"]');

    // Filter out hidden elements (duplicated page and article resources) thanks
    // to this https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/offsetParent
    const allVisibleElements = Array.from(this.querySelectorAll('li, button.predictive-search__item')).filter(
      (element) => element.offsetParent !== null
    );
    if (!allVisibleElements.length) return;
    let activeElementIndex = 0;

    if (moveUp && !selectedElement) return;

    let selectedElementIndex = -1;
    let i = 0;

    while (selectedElementIndex === -1 && i <= allVisibleElements.length) {
      if (allVisibleElements[i] === selectedElement) {
        selectedElementIndex = i;
      }
      i++;
    }

    this.statusElement.textContent = '';

    if (!moveUp && selectedElement) {
      activeElementIndex = selectedElementIndex === allVisibleElements.length - 1 ? 0 : selectedElementIndex + 1;
    } else if (moveUp) {
      activeElementIndex = selectedElementIndex === 0 ? allVisibleElements.length - 1 : selectedElementIndex - 1;
    }

    if (activeElementIndex === selectedElementIndex) return;

    const activeElement = allVisibleElements[activeElementIndex];

    activeElement.setAttribute('aria-selected', true);
    if (selectedElement) selectedElement.setAttribute('aria-selected', false);

    this.input.setAttribute('aria-activedescendant', activeElement.id);
  }

  selectOption() {
    const selectedOption = this.querySelector('[aria-selected="true"] a, button[aria-selected="true"]');

    if (selectedOption) selectedOption.click();
  }

  async getSearchResults(searchTerm) {
    const request = this.mrRequest = (this.mrRequest || 0) + 1;
    this.setLiveRegionLoadingState();
    this.predictiveSearchResults.replaceChildren();
    this.open();
    const deferred = this.dispatchSearchUpdateEvent(searchTerm);
    try {
      const catalog = await MRSearchCatalog.load();
      if (request !== this.mrRequest || this.getQuery() !== searchTerm || !this.contains(document.activeElement)) return;
      const found = MRSearchCatalog.search(catalog.products, searchTerm), matches = found.products;
      const make = (tag, cls, text) => { const e = document.createElement(tag); if (cls) e.className = cls; if (text !== undefined) e.textContent = text; return e; };
      const root = make('div'); root.id = 'predictive-search-results'; root.setAttribute('role','listbox');
      const group = make('div','predictive-search__results-groups-wrapper'); group.id = 'predictive-search-results-groups-wrapper';
      const heading = make('h2','predictive-search__heading text-body caption-with-letter-spacing',catalog.labels.products); heading.id = 'predictive-search-products';
      const list = make('ul','predictive-search__results-list list-unstyled'); list.id = 'predictive-search-results-products-list'; list.setAttribute('role','group'); list.setAttribute('aria-labelledby',heading.id);
      matches.slice(0,8).forEach((p,i) => {
        const item = make('li','predictive-search__list-item mr-search-suggestion'); item.setAttribute('data-mr-catalog-card',''); item.id = 'predictive-search-option-product-' + i; item.setAttribute('role','option'); item.setAttribute('aria-selected','false');
        const link = make('a','predictive-search__item predictive-search__item--link-with-thumbnail link link--text'); link.href = p.url; link.tabIndex = -1;
        if (p.image) { const image = make('img','predictive-search__image'); image.src=p.image; image.alt=''; image.width=50; image.height=50; image.style.objectFit='contain'; link.append(image); }
        const content=make('div','predictive-search__item-content predictive-search__item-content--centered');
        content.append(make('p','predictive-search__item-heading h5',p.title),make('div','predictive-search__item-vendor',p.vendor)); link.append(content);
        const add=make('button','mr-product-card__add mr-search-add'); add.type='button';add.setAttribute('data-mr-catalog-add','');add.setAttribute('data-mr-search-hydrate','');add.setAttribute('data-mr-suggest-add','');
        const action=p.hasOptions?catalog.labels.options:catalog.labels.add;
        add.setAttribute('aria-label',action+' — '+p.title);
        add.append(make('span','mr-product-card__action',action),make('span','mr-product-card__plus','+'));add.lastChild.setAttribute('aria-hidden','true');
        const data=make('script');data.type='application/json';data.setAttribute('data-mr-catalog-data','');data.textContent=JSON.stringify(p).replace(/</g,'\u003c');
        item.append(link,add,data); list.append(item);
      });
      group.append(heading);
      if(found.correctedQuery)group.append(make('p','mr-search-empty',catalog.labels.corrected.replace('__TERM__',found.correctedQuery)));
      group.append(list);
      if (!matches.length) { const empty=make('p','mr-search-empty',catalog.labels.empty.replace('__TERM__',searchTerm)); group.append(empty); }
      root.append(group);
      const footer=make('div','predictive-search__search-for-button'); footer.id='predictive-search-option-search-keywords';
      const button=make('button','predictive-search__item predictive-search__item--term link link--text h5',catalog.labels.search.replace('__TERM__',searchTerm)); button.type='submit'; button.tabIndex=-1; button.setAttribute('role','option'); button.setAttribute('aria-selected','false'); footer.append(button); root.append(footer);
      const count=make('span','hidden',String(matches.length)); count.setAttribute('data-predictive-search-live-region-count-value',''); count.dataset.totalResults=String(matches.length); root.append(count);
      this.renderSearchResults(root.outerHTML);
      deferred?.resolve({totalCount:matches.length});
    } catch(error) { if (request === this.mrRequest) this.close(); deferred?.reject(error); }
  }

  getTotalResultCount() {
    return parseInt(this.predictiveSearchResults.querySelector('[data-total-results]')?.dataset.totalResults) || 0;
  }

  dispatchSearchUpdateEvent(query) {
    const { SearchUpdateEvent } = window.StandardEvents || {};
    if (!SearchUpdateEvent) return null;

    const deferred = SearchUpdateEvent.createPromise();
    this.dispatchEvent(
      new SearchUpdateEvent({
        search: { query },
        promise: deferred.promise,
      })
    );
    return deferred;
  }

  setLiveRegionLoadingState() {
    this.statusElement = this.statusElement || this.querySelector('.predictive-search-status');
    this.loadingText = this.loadingText || this.getAttribute('data-loading-text');

    this.setLiveRegionText(this.loadingText);
    this.setAttribute('loading', true);
  }

  setLiveRegionText(statusText) {
    this.statusElement.setAttribute('aria-hidden', 'false');
    this.statusElement.textContent = statusText;

    setTimeout(() => {
      this.statusElement.setAttribute('aria-hidden', 'true');
    }, 1000);
  }

  renderSearchResults(resultsMarkup) {
    this.predictiveSearchResults.innerHTML = resultsMarkup;
    this.setAttribute('results', true);

    this.setLiveRegionResults();
    this.open();
  }

  setLiveRegionResults() {
    this.removeAttribute('loading');
    this.setLiveRegionText(this.querySelector('[data-predictive-search-live-region-count-value]').textContent);
  }

  getResultsMaxHeight() {
    this.resultsMaxHeight =
      window.innerHeight - document.querySelector('.section-header')?.getBoundingClientRect().bottom;
    return this.resultsMaxHeight;
  }

  open() {
    this.predictiveSearchResults.style.maxHeight = this.resultsMaxHeight || `${this.getResultsMaxHeight()}px`;
    this.setAttribute('open', true);
    this.input.setAttribute('aria-expanded', true);
    this.isOpen = true;
  }

  close(clearSearchTerm = false) {
    this.closeResults(clearSearchTerm);
    this.isOpen = false;
  }

  closeResults(clearSearchTerm = false) {
    if (clearSearchTerm) {
      this.input.value = '';
      this.removeAttribute('results');
    }
    const selected = this.querySelector('[aria-selected="true"]');

    if (selected) selected.setAttribute('aria-selected', false);

    this.input.setAttribute('aria-activedescendant', '');
    this.removeAttribute('loading');
    this.removeAttribute('open');
    this.input.setAttribute('aria-expanded', false);
    this.resultsMaxHeight = false;
    this.predictiveSearchResults.removeAttribute('style');
  }
}

customElements.define('predictive-search', PredictiveSearch);

(function () {
  function make(tag, cls, text) { const e=document.createElement(tag); if(cls)e.className=cls;if(text!==undefined)e.textContent=text;return e; }
  document.addEventListener('click', async event => {
    const button=event.target.closest('[data-mr-search-hydrate]'); if(!button)return;
    event.preventDefault();event.stopImmediatePropagation();if(button.disabled)return;button.disabled=true;button.setAttribute('aria-busy','true');
    const card=button.closest('[data-mr-catalog-card]'), data=card.querySelector('[data-mr-catalog-data]'), p=JSON.parse(data.textContent);
    try {
      const response=await fetch(p.url+'.js',{credentials:'same-origin'});if(!response.ok)throw new Error('Product unavailable');const product=await response.json();
      p.variants=product.variants.map(v=>({id:v.id,title:v.title,options:v.options,image:v.featured_image?.src||p.image}));
      p.options=product.options.map(o=>typeof o==='string'?{name:o,values:[]}:o);p.hasOptions=!(p.variants.length===1&&p.variants[0].title==='Default Title');
      data.textContent=JSON.stringify(p);button.removeAttribute('data-mr-search-hydrate');button.disabled=false;button.removeAttribute('aria-busy');button.click();
    } catch(error) { location.assign(p.url); }
  }, true);
  async function init() {
    const main=document.querySelector('#MainContent[data-template="search"]'),query=new URLSearchParams(location.search).get('q')||'';
    if(!main||!query.trim()||/\b(?:title|vendor|tag|product_type):/i.test(query))return;
    const root=main.querySelector('.template-search'),header=root?.querySelector('.template-search__header');if(!root||!header)return;
    const old=Array.from(root.children).filter(e=>e!==header);old.forEach(e=>e.hidden=true);root.setAttribute('aria-busy','true');
    try {
      const catalog=await MRSearchCatalog.load(),found=MRSearchCatalog.search(catalog.products,query),products=found.products;
      old.forEach(e=>e.remove());header.querySelectorAll(':scope > p').forEach(e=>e.remove());root.classList.remove('template-search--empty');
      const region=make('div','page-width mr-search-matches'),count=make('p','mr-search-count',catalog.labels.products+': '+products.length),grid=make('ul','grid product-grid');grid.id='product-grid';if(found.correctedQuery)region.append(make('p','mr-search-empty',catalog.labels.corrected.replace('__TERM__',found.correctedQuery)));region.append(count,grid);root.append(region);
      if(!products.length)region.append(make('p','mr-search-empty',catalog.labels.empty.replace('__TERM__',query)));
      let shown=0;const more=make('button','mr-search-more',catalog.labels.more);
      function batch() {
        products.slice(shown,shown+24).forEach(p=>{
          const li=make('li','grid__item'),card=make('article','mr-product-card');card.setAttribute('data-mr-catalog-card','');
          const link=make('a','mr-product-card__image');link.href=p.url;link.setAttribute('aria-label',p.title);
          if(p.image){const image=make('img');image.src=p.image.replace(/width=100(?=&|$)/,'width=600');image.alt=p.title;image.loading='lazy';link.append(image)}
          const add=make('button','mr-product-card__add');add.type='button';add.setAttribute('data-mr-catalog-add','');add.setAttribute('data-mr-search-hydrate','');add.setAttribute('aria-label',(p.hasOptions?catalog.labels.options:catalog.labels.add)+' — '+p.title);
          add.append(make('span','mr-product-card__action',p.hasOptions?catalog.labels.options:catalog.labels.add),make('span','mr-product-card__plus','+'));add.lastChild.setAttribute('aria-hidden','true');
          const info=make('div','mr-product-card__info'),title=make('h3'),name=make('a','',p.title);name.href=p.url;name.title=p.title;title.append(name);info.append(title,make('p','mr-product-card__brand',p.vendor));
          const data=make('script');data.type='application/json';data.setAttribute('data-mr-catalog-data','');data.textContent=JSON.stringify(p);card.append(link,add,info,data);li.append(card);grid.append(li);
        });shown+=24;more.hidden=shown>=products.length;
      }
      more.type='button';more.onclick=batch;region.append(more);batch();
    } catch(error) {old.forEach(e=>e.hidden=false);} finally {root.removeAttribute('aria-busy');}
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
})();
